import React, { forwardRef, TextareaHTMLAttributes } from "react";
import { Textarea } from "@headlessui/react";

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string | undefined;
  className?: string | undefined;
  accept?: string | undefined;
  alt?: string | undefined;
  disabled?: boolean | undefined;
  name?: string | undefined;
  placeholder?: string | undefined;
  required?: boolean | undefined;
  id?: string | undefined;
  ref?: any;
  labelClass?: any;
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  ({ label, id,  ...props }, ref) => {
    const defaultLabelClass = "mb-2 text-xl text-dark02";
    const extraClass = props.labelClass ?? defaultLabelClass;

    return (
      <div className="flex flex-col mt-4">
        {label && (
          <label htmlFor={id} className={extraClass}>
            {label}
          </label>
        )}
        <Textarea id={id} ref={ref} {...props} />
      </div>
    );
  }
);

TextArea.displayName = "TextArea";

export default TextArea;
